module.exports = __webpack_public_path__ + "media/music.f521f960.mp3";